/* NOWA — reklam parametrelerinin sayfalar arası taşınması
   ═══════════════════════════════════════════════════════════════════════

   SORUN
   Reklamdan gelen ziyaretçinin adresi benzersizdir; kampanya ve tıklama
   kimliklerini taşır (utm_*, fbclid, gclid, ttclid …). Bu parametreler
   yalnızca ilk açılan sayfanın URL'sinde bulunur. Ziyaretçi listicle'dan
   ürün sayfasına, oradan sepete geçtiğinde düşerler ve satış hangi
   reklamdan geldiği bilinmeden kaydedilir.

   ÇÖZÜM
   Parametreler ilk açılışta yakalanır, sessionStorage'a yazılır ve mağaza
   içindeki tüm bağlantılara eklenir. Ziyaretçi kaç sayfa gezerse gezsin
   ödemeye kadar taşınırlar.

   NEDEN LIQUID DEĞİL
   Shopify'ın `request` nesnesi query string'i açığa çıkarmaz — sunucu
   tarafında bu bilgiye erişmenin yolu yoktur. Zorunlu olarak istemci
   tarafında çözülür.

   KAPSAM — yasak liste mantığı
   `?` işaretinden sonraki HER parametre taşınır. Böylece yarın çıkacak bir
   reklam ağının bilmediğimiz tıklama kimliği de, elle eklenen özel bir
   parametre de kendiliğinden taşınır.

   Yalnızca aşağıdaki BLOCKED listesi hariç tutulur. Bunlar kampanya kimliği
   değil, "o anki sayfanın durumu" veya güvenlik jetonudur; her linke
   yapışırlarsa yanlış davranış üretirler.

   Parametreler yalnızca mağazaya ait adreslere eklenir — üçüncü taraflara
   kampanya bilgisi sızdırılmaz.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Taşınmayacak parametreler. Kısaltmak isterseniz en kritik olanlar
     hesap/jeton grubudur; gerisi düşük riskli temizliktir. */
  var BLOCKED_NAMES = [
    // Hesap ve güvenlik akışları — her linke yapışırsa akışı bozar
    'token', 'key', 'return_url', 'checkout_url', 'customer_posted', 'challenge', 'form_type',
    // Shopify şifre sayfası bypass
    '_ab', '_fd', '_sc',
    // Tema / render iç parametreleri
    'view', 'preview_theme_id', 'section_id', 'sections',
    // Sayfa durumu — kampanya kimliği değil, o anki görünüm
    'variant', 'page', 'sort_by', 'q', 'type', 'options'
  ];
  var BLOCKED_PREFIXES = ['filter.', 'filter_'];

  /* Bu parametrelerden biri varsa YENİ bir reklam tıklaması sayılır ve depo
     tümüyle yenisiyle değiştirilir. Yoksa site içi gezinmedir; yeni
     parametreler mevcut setin üstüne eklenir, kampanya kimliği korunur.
     (Aksi hâlde ortada `?discount=LATO` gibi bir linke tıklamak utm'leri
     silerdi.) */
  var CAMPAIGN_MARKERS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_id',
    'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'twclid',
    'msclkid', 'epik', 'rdt_cid', 'li_fat_id', 'sccid', 'irclickid', 'yclid'
  ];
  var STORAGE_KEY = 'nowa_ad_params';

  function isBlocked(key) {
    var lower = key.toLowerCase();
    for (var i = 0; i < BLOCKED_PREFIXES.length; i++) {
      if (lower.indexOf(BLOCKED_PREFIXES[i]) === 0) return true;
    }
    for (var j = 0; j < BLOCKED_NAMES.length; j++) {
      if (lower === BLOCKED_NAMES[j]) return true;
    }
    return false;
  }

  function hasCampaignMarker(search) {
    var p = new URLSearchParams(search);
    for (var i = 0; i < CAMPAIGN_MARKERS.length; i++) {
      if (p.get(CAMPAIGN_MARKERS[i])) return true;
    }
    return false;
  }

  function readStored() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeStored(params) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    } catch (e) {
      /* Gizli sekme veya depolama kapalı — yalnızca bu sayfada çalışır */
    }
  }

  /* Adreste kampanya kimliği varsa YENİ tıklama: depo sıfırdan yazılır.

     Birleştirmek yanlış attribution üretirdi — ziyaretçi önce Facebook, sonra
     TikTok reklamına tıklarsa `utm_source=tiktok` ile eski `fbclid` yan yana
     kalır ve satış iki kanala birden yazılır. Son tıklama kazanır.

     Kampanya kimliği yoksa site içi gezinmedir: depodaki set korunur,
     adreste yeni parametre varsa üstüne eklenir. */
  function collectParams() {
    var taze = hasCampaignMarker(window.location.search);
    var params = taze ? {} : readStored();
    var degisti = taze;

    /* Değeri olmayan parametreler de taşınır (`?kokok` gibi bayrak biçimi).
       URL'e `kokok=` olarak eklenirler — işlevsel olarak aynı şey. */
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (isBlocked(key)) return;
      if (params[key] === value) return;
      params[key] = value;
      degisti = true;
    });

    if (degisti) writeStored(params);
    return params;
  }

  function isInternal(url) {
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    var host = url.hostname.toLowerCase();
    if (host === window.location.hostname.toLowerCase()) return true;
    return /(^|\.)mojanowa\.pl$/.test(host) || /\.myshopify\.com$/.test(host);
  }

  function decorate(anchor, params) {
    var raw = anchor.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') return;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(raw)) return;

    var url;
    try {
      url = new URL(raw, window.location.href);
    } catch (e) {
      return;
    }
    if (!isInternal(url)) return;

    // Bağlantıda o parametre zaten varsa dokunulmaz — elle konmuş olabilir.
    var changed = false;
    Object.keys(params).forEach(function (key) {
      if (url.searchParams.has(key)) return;
      url.searchParams.set(key, params[key]);
      changed = true;
    });

    if (changed) anchor.setAttribute('href', url.toString());
  }

  function init() {
    // Tema editöründe gezinme yok; bağlantıları kirletmeye gerek de yok.
    if (window.Shopify && window.Shopify.designMode) return;

    var params = collectParams();
    if (!Object.keys(params).length) return;

    function sweep(root) {
      (root || document).querySelectorAll('a[href]').forEach(function (a) {
        decorate(a, params);
      });
    }

    sweep();

    /* Sonradan eklenen bağlantılar (sepet çekmecesi, uygulama blokları,
       yorum widget'ı) ilk taramada yoktur. Tıklama anında yakalanır —
       capture aşamasında, tema kendi yönlendirmesini yapmadan önce. */
    ['click', 'auxclick'].forEach(function (type) {
      document.addEventListener(
        type,
        function (e) {
          var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
          if (a) decorate(a, params);
        },
        true
      );
    });

    document.addEventListener('shopify:section:load', function (e) {
      sweep(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
